import { Code } from '@ax/constants';

export interface GetAllAppointmentsApiResponse {
  uuid?: string;
  patientFirstName?: string;
  patientLastName?: string;
  appointmentStartTime?: string;
  patientAge?: number;
  patientGender?: string;
  chiefComplaint?: string;
  roomNumber?: string;
}

export interface getAllAppointmentsParams {
  doctorId: string;
  date: string;
  adminDoctorId?: string;
}

interface PatientInfo {
  firstName?: string;
  patientAge?: number;
  gender?: string;
  chiefComplaint?: string;
}

export interface SaveEHRAppointmentInput {
  doctorId: number;
  date?: string;
  startTime?: string;
  roomNumber?: string;
  patient?: PatientInfo;
}

export interface UpdateEHRAppointmentInput {
  appointmentId: string;
  doctorId?: number;
  startTime?: string;
  roomNumber?: string;
  patient?: PatientInfo;
  reminderAvailability?: string;
}

export interface DeleteEHRAppointmentInput {
  appointmentUuid: string;
}

export interface UploadEHRNoteInput {
  appointmentUuid: string;
  updates?: NoteUpdate[];
}

export interface NoteItem {
  __typename: string;
  Section: string;
  selection: string;
  Content: string;
  Order: number;
  CreatedAt: string;
  UpdatedAt: string;
  ActionSource: string;
  templateSelection?: {
    ComplaintId: number;
    ComplaintName: string;
    codes: Code[];
  };
}

export interface NoteSectionSentence {
  ComplaintId: number;
  ComplaintName: string;
  sentences: {
    Sentence: string;
    Section: string;
    Order: number;
    CreatedAt: string;
    selection: string;
  }[];
}

export interface NoteUpdate {
  noteSection: string;
  replace: boolean;
  text: string;
}

export enum NOTE_SOURCE {
  ATHENA = 'ATHENA',
  EPIC = 'EPIC',
  HCA = 'HCA',
  CERNER = 'CERNER',
  MEDITECH = 'MEDITECH',
  MANUAL = 'MANUAL',
}
